<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <h2 class="m-0 h1 text-uppercase">{{ $t('perfil.completar_datos') }}</h2>
        <div class="subtitle h3 light mb-4">
            <template v-if="this.entradasLocal.length === 1">
                {{ $t('perfil.introduce_nuevos_datos_entrada', { entrada: manager.termino_entrada }) }}
            </template>
            <template v-else>
                {{ $t('perfil.introduce_nuevos_datos_entradas', { entradas: manager.termino_entradas }) }}
            </template>
            <h5 class="bold mt-1">{{ $t('perfil.coste_cambio', { entrada: manager.termino_entrada, coste_cambio_nombre: $n(coste_cambio_nombre, "currency") }) }}</h5>
        </div>
        <b-row>
            <b-col 
                v-for="(entrada, index) in entradasLocal" 
                :key="entrada.id" 
                cols="12" 
                lg="6" 
                class="mb-md-3"
            >
                <b-card 
                    class="shadow-sm h-100"
                >
                    <template #header>
                        <h6 class="mb-0">
                            🎟️ {{ $t('perfil.entrada') }} #{{ entrada.qr_code }}
                        </h6>
                    </template>
                    
                    <b-card-text>
                        <b-row>
                            <b-col cols="12">
                                <FormInput
                                    :label="$t('formularios.nombre')"
                                    :id="'nombre-' + (index + 1)"
                                    :data-cy="'nombre-' + (index + 1)"
                                    :name="$t('perfil.nombre_entrada', { entrada: manager.termino_entrada, index: index+1 })"
                                    rules="required" 
                                    v-model="entrada.user_nombre"
                                />
                            </b-col>

                            <b-col cols="12">
                                <FormInput
                                    :label="$t('formularios.apellidos')"
                                    :id="'apellidos-' + (index + 1)"
                                    :data-cy="'apellidos-' + (index + 1)"
                                    :name="$t('perfil.apellidos_entrada', { entrada: manager.termino_entrada, index: index+1 })"
                                    rules="required" 
                                    v-model="entrada.user_apellidos"
                                />
                            </b-col>

                            <b-col cols="12">
                                <DocumentoTipo
                                    :id="'tipo-documento-comprador-' + (index + 1)"
                                    :value="entrada.tipoDocumentoSeleccionado.type"
                                    :index="index + 1"
                                    @input="val => { entrada.tipoDocumentoSeleccionado.type = val; entrada.user_dni = ''; }"
                                />
                            </b-col>

                            <b-col cols="12">
                                <DocumentoValor
                                    :type="entrada.tipoDocumentoSeleccionado.type"
                                    :value="entrada.user_dni"
                                    :index="index + 1"
                                    @input="val => { entrada.user_dni = val; }"
                                />
                            </b-col>
                        </b-row>
                    </b-card-text>
                    
                    <template #footer>
                        <small class="text-muted">
                            {{ entrada.asiento ? $t('perfil.info_asiento', { zona: entrada.asiento.zona, fila: entrada.asiento.fila, asiento: entrada.asiento.asiento }) : '' }}
                        </small>
                    </template>
                </b-card>
            </b-col>
        </b-row>

        <div class="mt-4 text-right">
            <button @click="$emit('volver')" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" data-cy="volver-cambiar-datos-paso-uno" id="volver-cambiar-datos-paso-uno">
                <span>{{ $t('formularios.atras') }}</span>
            </button>
            <button type="submit" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" data-cy="cambiar-datos-paso-dos" id="cambiar-datos-paso-dos">
                <span>{{ $t('formularios.continuar') }}</span>
            </button>
        </div>
    </ValidationObserver>
</template>

<script>
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        props: {
            entradas: {
                type: Array,
                required: true
            },
            esMovil: {
                type: Boolean,
                required: false,
                default: false
            },
            coste_cambio_nombre: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                entradasLocal: [ ...this.entradas ],
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" },
                    { type: "OTROS", value: "" }
                ]
            };
        },
        methods: {
            submit() {
                this.$refs.observer.validate().then(isValid => {
                    if (isValid) {
                        this.finalizar();
                    }
                });
            },
            finalizar() {
                const payloadCarrito = this.entradasLocal.map(entrada => ({
                    user_ticket_id: entrada.id,
                    nombre: entrada.user_nombre,
                    apellidos: entrada.user_apellidos,
                    dni: entrada.user_dni
                }));

                this.$emit('terminado', this.entradasLocal, payloadCarrito);
            },
            detectarTipoDocumento(dniValue) {
                if (!dniValue) return "DNI";

                const normalizedDni = dniValue.toUpperCase().trim();

                if (/^\d{8}[A-Z]$/.test(normalizedDni)) {
                    return "DNI";
                }
                
                if (/^[XYZ]\d{7}[A-Z]$/.test(normalizedDni)) {
                    return "NIE";
                }

                if (/^[A-HJNPQRSUVW]\d{7}[0-9A-J]$/.test(normalizedDni)) {
                    return "NIF";
                }
                return "PASAPORTE"; 
            },
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        created() {
            this.entradasLocal = this.entradas.map(entrada => {
                const tipoInicial = this.detectarTipoDocumento(entrada.user_dni);

                return {
                    ...entrada,
                    tipoDocumentoSeleccionado: {
                        type: tipoInicial,
                        value: entrada.user_dni || ''
                    }
                };
            });
        },
        components: {
            DocumentoTipo,
            DocumentoValor
        }
    };
</script>